import React from 'react';
import { render } from 'react-dom';
import {parseDataToProps} from "../../helpers";

const orderSummaryNodes = document.querySelectorAll('.order-summary');

if (orderSummaryNodes.length > 0) {
    import(/* webpackChunkName: "ObservingOrderSummary" */ './components/OrderSummary').then(({ObservingOrderSummary: ObservingOrderSummary}) => {
        [...orderSummaryNodes].forEach((node) => render(<ObservingOrderSummary {...parseDataToProps(node.dataset)} />, node));
    });
}
